import numeral from 'numeral';
import { replace } from 'lodash';

// Set Indian currency format
// numeral.defaultFormat('$0,0.00');

// // Define Indian locale
// numeral.register('locale', 'in', {
//   delimiters: {
//       thousands: ',',
//       decimal: '.'
//   },
//   abbreviations: {
//       thousand: 'k',
//       million: 'm',
//       billion: 'b',
//       trillion: 't',
//       lakh: 'l',
//       crore: 'cr'
//   },
//   currency: {
//       symbol: '₹'
//   }
// });

// Switch to Indian locale
numeral.locale('in');

export function fCurrency(number) {
  return numeral(number).format(Number.isInteger(number) ? '$0,0' : '$0,0.00');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  return numeral(number).format('0.0a').replace('m', 'cr');
}

export function fShortenNumber(number) {
  // if(number!==null && number!==undefined)
  //   return replace(numeral(number).format('0.00a'), '.00', '');

/* eslint-disable */

if (number !== null && number !== undefined) {
  if (number >= 10000000) {
    const crore = Math.floor(number / 10000000);
    const remaining = number % 10000000;
    const lakh = Math.floor(remaining / 100000);
    const thousand = Math.floor((remaining % 100000) / 1000);
    let formattedNumber = `${crore} Cr`;
    if (lakh > 0) {
     // formattedNumber += ` ${lakh} L`;
      return `${crore}.${lakh} Cr`
    }
    // if (thousand > 0) {
    //   formattedNumber += ` ${thousand} K`;
      
    // }

    return formattedNumber
  

  } else if (number >= 100000) {
    const lakh = Math.floor(number / 100000);
    const remaining = number % 100000;
    const thousand = Math.floor(remaining / 1000);
    let formattedNumber = `${lakh} L`;
    if (thousand > 0) {
      //formattedNumber += ` ${thousand} K`;
      return `${lakh}.${thousand} L`
    }
    return formattedNumber;
  } else if (number >= 1000) {
    const thousand = Math.floor(number / 1000);
    const hundred = number % 1000;
    let formattedNumber = `${thousand} K`;
    if (hundred > 0) {
      const h = String(hundred)?.slice(0,2)
      return `${thousand}.${h } K`
    }
    return formattedNumber;

  } else {
    return `${number}`;
  }
}

  /* eslint-enable */


  // if (number !== null && number !== undefined) {
  //   if (number < 100000) {
  //     return numeral(number).format('0.00a').replace('m', ' Million').replace('b', ' Billion').replace('t', ' Trillion');
  //   }

  //     const crore = Math.floor(number / 10000000);
  //     const remaining = number % 10000000;
  //     const crorePart = crore > 0 ? `${crore}${crore > 1 ? ' Cr' : ' Cr'}` : '';
  //     if (remaining > 0) {
  //       const lakh = Math.floor(remaining / 100000);
  //       const thousand = Math.floor((remaining % 100000) / 1000);
  //       const remainingPart = `${lakh > 0 ? `${lakh}${lakh > 1 ? ' L' : ' L'}` : ''} ${thousand > 0 ? `${thousand} k` : ''}`;
  //       return `${crorePart} ${remainingPart}`.trim();
  //     } 
  //       return crorePart;
      
  //   }
  

  // if (number !== null && number !== undefined) {
  //   if (number < 100000) {
  //     return numeral(number).format('0.00a').replace('m', ' Million').replace('b', ' Billion').replace('t', ' Trillion');
  //   } 
    
  
  //     const crore = Math.floor(number / 10000000);
  //     const remaining = number % 10000000;
  //     const crorePart = `${crore}${crore > 1 ? ' crores' : ' crore'}`;
  //     if (remaining > 0) {
  //       const lakh = Math.floor(remaining / 100000);
  //       const thousand = Math.floor((remaining % 100000) / 1000);
  //       const remainingPart = `${lakh > 0 ? `${lakh}${lakh > 1 ? ' lakhs' : ' lakh'}` : ''} ${thousand > 0 ? `${thousand} k` : ''}`;
  //       return `${crorePart} ${remainingPart}`.trim();
  //     } 
  //       return crorePart;
      
    
  // }

  // if (number !== null && number !== undefined) {
  //     let formattedNumber = numeral(number).format('0.00a');
  //     if (number >= 100000 && formattedNumber.includes('k')) {
  //       formattedNumber = formattedNumber.replace('k', 'L');
  //     } else if (formattedNumber.includes('m')) {
  //       formattedNumber = formattedNumber.replace('m', 'Cr');
  //     }
  //     return formattedNumber.replace('.00', '');
  //   }

  // if (number !== null && number !== undefined) {
  //   let formattedNumber = numeral(number).format('0,0');
  //   if (number >= 10000000) {
  //     const crore = Math.floor(number / 10000000);
  //     const lakh = Math.floor((number % 10000000) / 100000);
  //     const remaining = number % 100000;
  //     formattedNumber = `${crore} Cr ${lakh} L ${numeral(remaining).format('0,0')}`;
  //   }
  //   return formattedNumber;
  // }

/* eslint-disable */
// if (number !== null && number !== undefined) {
//   let formattedNumber = numeral(number).format('0,0');
//   if (number >= 10000000) {
//     const crore = Math.floor(number / 10000000);
//     const lakh = Math.floor((number % 10000000) / 100000);
//     const remaining = number % 100000;
//     let result = `${crore > 1 ? crore + ' Cr' : crore + ' Cr'}`;
//     if (lakh > 0) {
//       result += ` ${lakh > 1 ? lakh + ' L' : lakh + ' L'}`;
//     }
//     if (remaining > 0) {
//       result += ` ${numeral(remaining).format('0,0')}`;
//     }
//     formattedNumber = result;
//   } else if (number >= 100000) {
//     const lakh = Math.floor(number / 100000);
//     const remaining = number % 100000;
//     let result = `${lakh > 1 ? lakh + ' L' : lakh + ' L'}`;
//     if (remaining > 0) {
//       result += ` ${numeral(remaining).format('0,0')}`;
//     }
//     formattedNumber = result;
//   }
//   return formattedNumber;
// }

  /* eslint-enable */

  // if (number !== null && number !== undefined) {
  //   let formattedNumber = numeral(number).format('0.00a');
  //   if (formattedNumber.includes('k')) {
  //     formattedNumber = formattedNumber.replace('k', 'k');
  //   } else if (formattedNumber.includes('m')) {
  //     formattedNumber = formattedNumber.replace('m', 'cr');
  //   }

  //   if (formattedNumber.includes('cr')) {
  //     const crore = Math.floor(number / 10000000);
  //     const remaining = number % 10000000;
  //     const crorePart = `${crore}${crore > 1 ? ' crores' : ' crore'}`;
  //     if (remaining > 0) {
  //       const lakh = Math.floor(remaining / 100000);
  //       const thousand = Math.floor((remaining % 100000) / 1000);
  //       const remainingPart = `${lakh > 0 ? `${lakh}${lakh > 1 ? ' lakhs' : ' lakh'}` : ''} ${thousand > 0 ? `${thousand} k` : ''}`;
  //       formattedNumber = `${crorePart} ${remainingPart}`.trim();
  //     } else {
  //       formattedNumber = crorePart;
  //     }
  //   }

  //   return formattedNumber;
  // }

}

export function fData(number) {
  return numeral(number).format('0.0 b');
}
